import React from "react";
import Redirect from "components/Redirect";

const Encryption: React.FC = () => <Redirect to="/architecture" />;

export default Encryption;
